import { Input, Select, Option } from '@material-tailwind/react'

export function FiltersBar({
  q, setQ,
  stateFilter, setStateFilter,
  dateFrom, setDateFrom,
  dateTo, setDateTo,
}) {
  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="w-full sm:w-56">
        <Input
          label="Buscar en todo el historial"
          value={q}
          onChange={e => setQ(e.target.value)}
          crossOrigin=""
          containerProps={{ className: 'w-full min-w-0' }}
          className="!w-full min-w-0"
        />
      </div>

      <div className="w-full sm:w-44">
        <Select label="Estado" value={stateFilter} onChange={setStateFilter}>
          <Option value="all">Todas</Option>
          <Option value="expired">Aprobadas</Option>
          <Option value="rejected">Rechazadas</Option>
        </Select>
      </div>

      {/* Desde */}
      <div className="w-full sm:w-auto">
        <label className="block text-sm text-gray-700 mb-1">Desde</label>
        <input
          type="date"
          value={dateFrom}
          onChange={e => setDateFrom(e.target.value)}
          className="block w-full min-w-0 rounded-md border border-gray-300 bg-white px-3 py-2 text-gray-900 text-[16px] focus:border-blue-500 focus:outline-none"
        />
      </div>

      {/* Hasta */}
      <div className="w-full sm:w-auto">
        <label className="block text-sm text-gray-700 mb-1">Hasta</label>
        <input
          type="date"
          value={dateTo}
          onChange={e => setDateTo(e.target.value)}
          className="block w-full min-w-0 rounded-md border border-gray-300 bg-white px-3 py-2 text-gray-900 text-[16px] focus:border-blue-500 focus:outline-none"
        />
      </div>
    </div>
  )
}